import angular from 'angular';

angular.module('estimationApp', []);
